const shortTimeFormatter = new Intl.DateTimeFormat("en-US", {
  timeStyle: "short",
});

/** Converts a date to a short time string. */
export const toShortTime = (date: Date): string =>
  shortTimeFormatter.format(date);

const shortDateFormatter = new Intl.DateTimeFormat("en-US", {
  dateStyle: "short",
});

/** Converts a date to a short date string. */
export const toShortDate = (date: Date): string =>
  shortDateFormatter.format(date);

/** Converts a date to an ISO format string (YYYY-MM-DD). */
export const toIsoFormat = (date: Date): string => date.toISOString();

/** Converts an ISO date string to a human-readable relative time. */
export const toRelativeTime = (isoDate: string): string => {
  const diffMs = Date.now() - new Date(isoDate).getTime();
  const diffMin = Math.floor(diffMs / 60_000);
  const diffHr = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHr / 24);

  if (diffMin < 1) return "just now";
  if (diffMin < 60) return `${diffMin}m ago`;
  if (diffHr < 24) return `${diffHr}h ago`;
  if (diffDay === 1) return "yesterday";
  if (diffDay < 7) return `${diffDay}d ago`;
  if (diffDay < 30) return `${Math.floor(diffDay / 7)}w ago`;
  if (diffDay < 365) return `${Math.floor(diffDay / 30)}mo ago`;
  return `${Math.floor(diffDay / 365)}y ago`;
};
